import React from "react";
import {
  WMS_FA_ATR_DEPRECIATION,
  WMS_FA_ATR_TINGKAT_ASSET,
  WMS_FA_ATR_TIPE_ASSET,
  WMS_FA_ATR_TIPE_FISCAL,
  WMS_FA_DAFTAR_NOTIFIKASI_ASSET,
  WMS_FA_DISPOSE_ASSET,
  WMS_FA_KALIBRASI,
  WMS_FA_MANAJEMEN_NOTIFIKASI,
  WMS_FA_MS_GOL_BARANG,
  WMS_FA_MS_GUDANG,
  WMS_FA_MS_TIPE_NOTIFIKASI,
  WMS_FA_MS_VD,
} from "App/constants";
import {
  DaftarNotifikasiAssetFixedAsset,
  DepreciationMethodFixedAsset,
  DisposeAssetFixedAsset,
  KalibrasiAssetFixedAsset,
  ManajemenNotifikasiFixedAsset,
  MasterGolonganBarangFixedAsset,
  MasterGudangFixedAsset,
  MasterTipeNotifikasi,
  MasterVendorFixedAsset,
  TingkatAssetFixedAsset,
  TipeAssetFixedAsset,
  TipeFiscalFixedAsset,
} from "../WrapperLazyExport";
import {} from "App/Component";

export const menuFixedAsset = {
  [WMS_FA_ATR_DEPRECIATION]: <DepreciationMethodFixedAsset />,
  [WMS_FA_ATR_TIPE_FISCAL]: <TipeFiscalFixedAsset />,
  [WMS_FA_ATR_TIPE_ASSET]: <TipeAssetFixedAsset />,
  [WMS_FA_ATR_TINGKAT_ASSET]: <TingkatAssetFixedAsset />,
  [WMS_FA_MS_TIPE_NOTIFIKASI]: <MasterTipeNotifikasi />,
  [WMS_FA_MS_GUDANG]: <MasterGudangFixedAsset />,
  [WMS_FA_MS_VD]: <MasterVendorFixedAsset />,
  [WMS_FA_MS_GOL_BARANG]: <MasterGolonganBarangFixedAsset />,
  [WMS_FA_MANAJEMEN_NOTIFIKASI]: <ManajemenNotifikasiFixedAsset />,
  [WMS_FA_DISPOSE_ASSET]: <DisposeAssetFixedAsset />,
  [WMS_FA_DAFTAR_NOTIFIKASI_ASSET]: <DaftarNotifikasiAssetFixedAsset />,
  [WMS_FA_KALIBRASI]: <KalibrasiAssetFixedAsset />,

};
